/*SYSTEM IMPORTS*/
import React from 'react'

import './style'
import './media'

import Img from "components/Img";

/*Ui*/
import Cont from 'components/ui/Cont'
import PartnersSlider from 'components/ui/PartnersSlider'
import PartnerItem from 'components/ui/PartnerItem'

import urlJoin from 'url-join'

import {Helpers} from "api"

const ContPartners = ({ id, value = [] }) => {
    const [load, setLoad] = React.useState(false)

    React.useEffect(() => {
        const loadImages = async () => {
            const promises = value.map(item => {
                return new Promise(ok => {
                    const { image_path } = window

                    let url = Helpers.GetImage(item.image[0], "full")
                    
                    url = urlJoin(image_path, url)

                    console.log("add load to queue: ", url)

                    const img = new Image()

                    img.onload = () => {
                        console.log("load success: ", url)

                        ok()
                    }

                    img.onerror = (event) => {
                        console.error("load fail: ", img.src)
                        console.error(event)
                    }

                    img.src = url
                })
            })

            Promise.all(promises).then(() => {
                setLoad(true)
            })
        }

        loadImages()
    }, [])

    return (
        <Cont id={`block-${id}`} className="cont-partners">
            {load && <PartnersSlider list={value.map(item => (
                <PartnerItem
                    key={item.id}
                    to={item.link}
                >
                    <Img src={`${Helpers.GetImage(item.image[0], "full")}`} externals/>
                </PartnerItem>
            ))} /> }
        </Cont>
    )
}

export default ContPartners 